import React, { ReactNode } from 'react'
import { css, cx } from '@emotion/css'
import { Card } from '@contrast-security-inc/design-system-surfaces'
import { Text } from '@contrast-security-inc/design-system-typography'
import { Stack } from '@contrast-security-inc/design-system-layouts'
import { theme } from '@contrast-security-inc/design-system-foundations'

const optionCss = css`
  width: 267px;
  grid-gap: 4px;
  cursor: pointer;
  border-radius: 8px;
  padding: 32px 30px;
  border: 4px solid ${theme.color.transparent};
  :hover,
  :focus-visible {
    border: 4px solid ${theme.color.turquoise70};
    outline: unset;
  }

  & > * {
    text-align: center;
  }

  svg {
    justify-self: center;
  }
`
const contentCss = css`
  height: 100%;
`

const titleCss = css`
  margin: 0px;
`

const descriptionCss = css`
  min-height: 96px;
  text-align: center;
  padding: 0px 16px;
`

const iconCss = css`
  padding: 16px;
`

export interface SelectSensorOptionParams {
  title: string
  type: string
  description: string
  icon: ReactNode
  onSelect: () => void
  testId: string
  className?: string
}
export const SelectSensorOption = ({
  title,
  type,
  description,
  icon,
  onSelect,
  testId,
  className
}: SelectSensorOptionParams) => {
  return (
    <Card
      className={cx(optionCss, className)}
      onClick={() => onSelect()}
      tabIndex={0}
      role="link"
      onKeyDown={(event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          onSelect()
        }
      }}
      testId={`select-sensor-${testId}`}
    >
      <Stack
        justifyContent="space-between"
        alignItems="center"
        flexDirection="column"
        className={contentCss}
      >
        <Stack flexDirection="column" spacing="4px">
          <Text font="titleH5" as="h5" className={titleCss}>
            {title}
          </Text>
          <Text color="neutral80">{type}</Text>
        </Stack>
        <div className={iconCss}>{icon}</div>
        <Text font="body" className={descriptionCss} color="neutral80">
          {description}
        </Text>
      </Stack>
    </Card>
  )
}
